export default "__VITE_ASSET__DKoV7kDh__"